import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  API_INITIATE_GET_FFWD_CUSTOMER_DATA,
  API_COMPLETE_GET_FFWD_CUSTOMER_DATA,
  API_INITIATE_SUBMIT_FFWD_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_FFWD_CUSTOMER_DATA,
} from '../../app-constants';
import { submitFFWDCustomerData, submitFFWDRequestCallback } from './ffwd-homepage.actions';
import View from './ffwd-homepage.presenter';

// Reducer
export const ffwdHomePageReducer = (state = {
  loading: false,
  dataLoaded: false,
  formSubmitted: false,
  customerAccountName: '',
  customerAccountNumber: '',
  customerAbn: '',
  customerBusinessName: '',
  alreadySubmitted: false,
  planDetails: {},
  suggestedPlanDetails: {},
  customerContactPhone: '',
  referenceNumber: '',
  totalCurrentDataInclusionPerMonth: '',
  totalFutureDataInclusionPerMonth: '',
  totalCurrentSpentPerMonth: '',
  totalFutureSpentPerMonth: '',
  benefitValues: {},
  telstraConnectOnboarded: false,
}, action) => {
  switch (action.type) {
    case API_INITIATE_GET_FFWD_CUSTOMER_DATA:
      return { ...state, loading: true, dataLoaded: false, formSubmitted: false };
    case API_INITIATE_SUBMIT_FFWD_CUSTOMER_DATA:
      return { ...state, loading: true };
    case API_COMPLETE_SUBMIT_FFWD_CUSTOMER_DATA:
      return { ...state, loading: false, formSubmitted: true, referenceNumber: action.data.referenceNumber };
    case API_COMPLETE_GET_FFWD_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: true,
        customerAccountName: action.data.accountName,
        customerAccountNumber: action.data.accountNumber,
        customerAbn: action.data.abn,
        customerBusinessName: action.data.businessName,
        planDetails: action.data.planDetails,
        suggestedPlanDetails: action.data.suggestedPlanDetails,
        alreadySubmitted: action.data.alreadySubmitted,
        customerContactPhone: action.data.contactNumber,
        totalCurrentDataInclusionPerMonth: action.data.totalCurrentDataInclusionPerMonth,
        totalFutureDataInclusionPerMonth: action.data.totalFutureDataInclusionPerMonth,
        totalCurrentSpentPerMonth: action.data.totalCurrentSpentPerMonth,
        totalFutureSpentPerMonth: action.data.totalFutureSpentPerMonth,
        benefitValues: action.data.benefitValues,
        telstraConnectOnboarded: action.data.telstraConnectOnboarded,
      };
    }
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  customerAccountNumber: state.ffwdHomePageReducer.customerAccountNumber,
  customerAccountName: state.ffwdHomePageReducer.customerAccountName,
  customerAbn: state.ffwdHomePageReducer.customerAbn,
  customerBusinessName: state.ffwdHomePageReducer.customerBusinessName,
  planDetails: state.ffwdHomePageReducer.planDetails,
  suggestedPlanDetails: state.ffwdHomePageReducer.suggestedPlanDetails,
  authorableContent: state.authorableContentReducer.authorableContent,
  dataLoaded: state.ffwdHomePageReducer.dataLoaded,
  formSubmitted: state.ffwdHomePageReducer.formSubmitted,
  alreadySubmitted: state.ffwdHomePageReducer.alreadySubmitted,
  customerContactPhone: state.ffwdHomePageReducer.customerContactPhone,
  referenceNumber: state.ffwdHomePageReducer.referenceNumber,
  totalCurrentDataInclusionPerMonth: state.ffwdHomePageReducer.totalCurrentDataInclusionPerMonth,
  totalFutureDataInclusionPerMonth: state.ffwdHomePageReducer.totalFutureDataInclusionPerMonth,
  totalCurrentSpentPerMonth: state.ffwdHomePageReducer.totalCurrentSpentPerMonth,
  totalFutureSpentPerMonth: state.ffwdHomePageReducer.totalFutureSpentPerMonth,
  benefitValues: state.ffwdHomePageReducer.benefitValues,
  telstraConnectOnboarded: state.ffwdHomePageReducer.telstraConnectOnboarded,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitFFWDCustomerData,
    submitFFWDRequestCallback,
  }, dispatch),
});

const FFWDHomePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);


export default FFWDHomePage;
